<template>
  <div class="hp-manager-page-list">
    <filter-form :filter="filter" @handleSubmit="handleSubmit">
    </filter-form>
    <standard-table ref="datas" size="default" :bordered="true" :columns="columns" :indentSize="15" :dataSource="datas" :pagination="pagination" :loading="loading" @tableChange="tableChange">
    </standard-table>
  </div>
</template>

<script>
import { api } from "@/common";

import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import config from "@/config";
import { setTimeout } from "timers";
let dealerTypeOptions = [];
let organizationOptions = [];
export default {
  mixins: [account, dateFormat, moneyFormat],
  data() {
    return {
      filter: [
        {
          type: "input",
          key: "productName",
          name: "产品名称"
        },
        {
          type: "dateFilter",
          key: "filterTime",
          name: "有效期"
        },
        {
          type: "select",
          key: "organizationId",
          name: "销售组织",
          options: organizationOptions
        },
        {
          type: "select",
          key: "dealerType",
          name: "客户类型",
          options: dealerTypeOptions
        }
      ],
      columns: [
        {
          title: "产品名称",
          dataIndex: "productName"
        },
        {
          title: "产品编码",
          width: 150,
          dataIndex: "productCode"
        },
        {
          title: "规格",
          width: 200,
          dataIndex: "specDes"
        },
        {
          title: "销售组织",
          width: 150,
          dataIndex: "organizationName"
        },
        {
          title: "客户类型",
          width: 150,
          dataIndex: "dealerTypeName"
        },
        {
          title: "价格",
          width: 150,
          dataIndex: "price"
        },
        {
          title: "有效期",
          width: 200,
          dataIndex: "startTime",
          customRender: (text, row, index) => {
            return (
              this.formatDate(row.startTime, "YYYY-MM-DD") +
              "~" +
              this.formatDate(row.endTime, "YYYY-MM-DD")
            );
          }
        }
      ],
      datas: [],
      filterdata: Object.assign(
        {
          startTime: null,
          endTime: null,
          productName: "",
          organizationId: null,
          dealerType: null
        },
        JSON.parse(JSON.stringify(config.pageFilter))
      ),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      permission: []
    };
  },
  async mounted() {
    this.GetDealerTypeOptions();
    this.GetOrganizationOptions();
    this.permission = this.getPermission("SalesPriceHistory");
    this.getDatas(this.filterdata);
  },
  methods: {
    handleSubmit(p) {
      this.pagination.current = 0;
      this.filterdata.startTime =
        p.values.filterTime[0] != null
          ? p.values.filterTime[0].startOf("day").valueOf()
          : null;
      this.filterdata.endTime =
        p.values.filterTime[1] != null
          ? p.values.filterTime[1].startOf("day").valueOf()
          : null;
      this.filterdata.productName = p.values.productName;
      this.filterdata.organizationId = p.values.organizationId;
      this.filterdata.dealerType = p.values.dealerType;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    async GetDealerTypeOptions() {
      let dictionary = await api.GetDictionaryForSelect({ type: 3 });
      if (dictionary) {
        dealerTypeOptions = [];
        dictionary.forEach(a => {
          dealerTypeOptions.push({
            name: a.text,
            val: a.value
          });
        });
      }
    },
    async GetOrganizationOptions() {
      let org = await api.GetOrganizationSelect();
      if (org) {
        organizationOptions = [];
        org.forEach(a => {
          organizationOptions.push({
            name: a.text,
            val: a.value
          });
        });
      }
    },
    refreshCurrent() {
      this.pagination.current = 0;
      this.addVisible = false;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.filters.code && table.filters.code.length > 0) {
        console.log(table.filters);
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },

    async getDatas(options) {
      this.loading = true;
      let data = await api.GetSalesPriceHistoryList(options);
      this.datas = data.items;
      console.log(data);
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/Goods/SalesPriceHistory/List.vue